import {IMAGE_DEFAULT_FORMATS} from "../../../core/app/consts";
import {ImageRequestParams} from "./image-request-params";

export class FetchImageRequestParams extends ImageRequestParams {
  constructor(width: Number, height: Number, ratio: Number) {
    super({width, height, ratio, c: 'fill'});

    this.g = 'auto';
  }

  get fullUrl(): String {
    return '';
  }

  get defaultFormat(): String {
    return IMAGE_DEFAULT_FORMATS.PNG;
  }

  get pathPostfix(): String {
    return `/${encodeURIComponent(this.fullUrl)}`;
  }

  toString(): String {
    const url = `${this.baseUrl.replace('upload', 'fetch')}${this.params}${this.pathPostfix}`;

    return url;
  }
}
